import React, { useMemo, useEffect } from 'react';
import Light from '../../../../../../assets/education/ptm/light.png';
import Person from '../../../../../../assets/education/ptm/person.png';
import VideoTranscript from '../../components/VideoTranscript/index';
import { WTitle } from '../../components/Widget';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';

interface ISection1Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const ID = '1';
  useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#videoPtm');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#videoPtm')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#videoPtm')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#videoPtm')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document?.querySelector('#videoPtm')?.removeEventListener('play', onPlay);
  }, []);
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  useEffect(() => {
    if (isVisible) {
      updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [isVisible]);
  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <div className="course-landing-text">
          <WTitle title={paragraphsSettings?.header} />
          <img className="person" src={Person} alt="" />
          <div className="course-box">
            <div className="video-container">
              <video
                id="videoPtm"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
            <img className="light" src={Light} alt="" />
          </div>
        </div>
      </div>
      <div className="welcome-bubble">
        <div className="welcome-bubble-content" ref={targetRef}>
          {isVisible && (
            <span className="text-focus-in">
              {paragraphsSettings?.description}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Section0;
